import {AUTH_ROUTES as authRoutes} from "~/api/routes";
import {getJWTToken, setJWTToken, getLoggedUser, setLoggedUser} from "~/helpers";
import Vue from "vue";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export const state = () => ({
  connected: false,
  jwt: getJWTToken(),
  user: getLoggedUser(),
  hasError: false,
  isLoading: false,
  profil: null
});

export const getters = {
  getUser: (state) => state.user,
  getJWTToken: (state) => state.jwt,
  getProfil: (state) => {
    try{
      return state.profil
    }catch(e){
    }
  }
};

export const mutations = {
  USER_CONNECTED(state) {
    state.connected = true;
  },
  SET_ERROR(state, hasError) {
    state.hasError = hasError;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  USER_DISCONNECTED(state) {
    state.connected = false;
  },
  SET_JWT(state, jwt) {
    setJWTToken(jwt);
    state.jwt = jwt;
  },
  SET_USER(state, user) {
    setLoggedUser(user);
    state.user = user;
  },
  GET_PROFIL(state, profil) {
    state.profil = profil
  },
  UPDATE_PROFIL(state) {

  }
};

export const actions = {
  logout({commit}, params) {
    commit('SET_JWT', null);
    commit('SET_USER', null);
    commit('USER_DISCONNECTED');
    localStorage.clear();
    //TODO: refactor
    const isPlannificationRoute = ('/planification' === window.location.pathname);
    if (!isPlannificationRoute || params.redirect) {
      this.$router.push({
        path: 'auth/connexion'
      });
    }
  },
  async forgot({commit, dispatch}, params) {
    // commit('SET_ERROR', false);
    // commit('SET_LOADING', true);
    await this.$api.request(authRoutes.forgot, {}, params)
      .then(response => {
        //commit('');
        const message = response._response ? response._response.message : "l'email de réinitialisation du mot de passe est envoyé";
        Vue.$toast.success(message);
      })
      .catch(error => {
        commit('SET_ERROR', true);
      });
    commit('SET_LOADING', false);
  },
  async reset({commit, dispatch}, params) {
    // commit('SET_ERROR', false);
    // commit('SET_LOADING', true);
    await this.$api.request(authRoutes.reset, {}, params)
      .then(response => {
        //commit('');
        const message = response._response ? response._response.message : "le mot de passe est à jour";
        Vue.$toast.success(message);
      })
      .catch(error => {
        commit('SET_ERROR', true);
      });
    commit('SET_LOADING', false);
  },
  async login({commit, dispatch}, params) {
    commit('SET_ERROR', false);
    commit('SET_LOADING', true);
    await this.$api.request(authRoutes.login, {}, params)
      .then(response => {
        commit('USER_CONNECTED');
        commit('SET_JWT', response.payload.token);
        commit('SET_USER', response.payload);
        //TODO: refactor
        const isPlannificationRoute = ('/planification' === window.location.pathname);
        if (!isPlannificationRoute) {
          if (response?.payload?.role === 'SUPERADMIN'){
            this.$router.push({
              path: '/'
            });
          } else {
            this.$router.push({name: 'planification'});
          }
        }
      })
      .catch(error => {
        commit('SET_ERROR', true);
      });
    commit('SET_LOADING', false);
  },
  async me({commit, dispatch}) {
    //commit('', false);
    await this.$api.request(authRoutes.me, {})
      .then(response => {
        commit('GET_PROFIL', response.payload);
      })
      .catch(error => {
        this.$router.push('auth/connexion');
      });
  },
  async update({commit, dispatch}, params) {
    //commit('', false);
    await this.$api.request(authRoutes.update, {}, params)
      .then(response => {
        this.dispatch('auth/logout');
        //commit('UPDATE_PROFIL', response.payload);
      })
      .catch(error => {
        //commit('', true);
      });
  },
  async check({commit},){
    await this.$api.request(authRoutes.check, {})
      .then(response => {

      })
      .catch(error => {
        this.dispatch('auth/logout');
        //commit('', true);
      });
  }
};
